import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { adminApi, setStoredToken } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [booting, setBooting] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await adminApi.get("/auth/me");
      setUser(r.data);
      return r.data;
    } catch (e) {
      setUser(null);
      return null;
    }
  }, []);

  useEffect(() => {
    (async () => {
      await refresh();
      setBooting(false);
    })();
  }, [refresh]);

  const login = async (username, password) => {
    const r = await adminApi.post("/auth/login", { username, password });
    if (r.data?.access_token) setStoredToken(r.data.access_token);
    setUser(r.data?.user || null);
    return r.data?.user;
  };

  const logout = async () => {
    try {
      await adminApi.post("/auth/logout");
    } catch (e) {
      /* ignore */
    }
    setStoredToken("");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, booting, login, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthCtx);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
}
